import Colors from "Common/colors";
import * as React from "react";

const Svg2CircularArrowsWithCheck = ({
  style = {},
  fill = "none",
  width = 18,
  className = "",
  color = Colors.black,
  viewBox = "0 0 18 18"
}) => (
  <svg
    width={width}
    height={width}
    style={style}
    viewBox={viewBox}
    fill={fill}
    className={`svg-icon ${className || ""}`}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g clipPath="url(#clip0_2197_202)">
      <path
        d="M17 4.34267C15.3501 2.30367 12.8273 1 10 1C6.46631 1 3.40825 3.03656 1.93555 6"
        stroke={color}
        strokeWidth={1.5}
      />
      <path d="M1.5 2.5V6H5" stroke={color} strokeWidth={1.5} />
      <path
        d="M1.49997 13.6573C3.14993 15.6963 5.67271 17 8.49997 17C12.0337 17 15.0918 14.9634 16.5645 12"
        stroke={color}
        strokeWidth={1.5}
      />
      <path d="M17 15.5L17 12L13.5 12" stroke={color} strokeWidth={1.5} />
      <path d="M5 8.875L8.07692 12L13 7" stroke={color} strokeWidth={1.5} />
    </g>
    <defs>
      <clipPath id="clip0_2197_202">
        <rect width={18} height={18} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Svg2CircularArrowsWithCheck;
